import {
  DateInput as NDateInput,
  type DateInputProps as NDateInputProps,
} from '@natera/material/lib/date'
import { cn } from '~/shared/lib/cn'
import './date-input.scss'

interface DateInputProps extends NDateInputProps {
  help?: boolean
}

export function DateInput({
  className,
  outline = true,
  dense = true,
  fullWidth = true,
  clearable = false,
  help = false,
  readOnly = false,
  disabled = false,
  ...rest
}: DateInputProps) {
  return (
    <NDateInput
      {...rest}
      className={cn(
        'c-date-input',
        {
          'c-date-input--help': help,
          'c-date-input--read-only': readOnly,
        },
        className,
      )}
      outline={outline}
      dense={dense}
      fullWidth={fullWidth}
      clearable={clearable}
      materialDropdownIcon="arrow_drop_down"
      materialArrowIcon="chevron_right"
      materialClearIcon="close"
      materialTrailingIcon="event"
      materialLeadIcon={
        help
          ? {
              children: 'help',
              fill: true,
            }
          : undefined
      }
      disabled={disabled || readOnly}
    />
  )
}
